import React from 'react'
import {  VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './custom-styles.css';
import StarsCanvas from '../../3d/Stars';
const ExperienceCard = ({experience}) => {
  return (
    <>
 
    

    
    
    
    <VerticalTimelineElement
    contentStyle={{ background: '#000', color: '#000' }}
    contentArrowStyle={{ borderRight: '7px solid black' }}
    date={experience.date}
    iconStyle={{ background: '#000', color: '#000' }} // Customize icon background
  
 icon={
    <div>
        <img src={experience.icon} 
        style={{borderRadius:'50px',height:'60px',color:'#000000'}}
      
        alt={experience.comapany_name}

        />
    </div>
 }
 >
    <div className="">
        <h3 className='text-[#915eff] text-[20px] mb-2'>
            {experience.company_name}
        </h3>
        <p className='text-gray-400'>
            {experience.points}
            
        </p>
    </div>
 

 </VerticalTimelineElement>
 
 </>
  )
}

export default ExperienceCard